"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAND_ALONE_COMPONENTS = void 0;
var _VerifyEmailContainer = _interopRequireDefault(require("../components/VerifyEmail/VerifyEmailContainer"));
var _ResetPasswordFormContainer = _interopRequireDefault(require("../components/ResetPasswordForm/ResetPasswordFormContainer"));
var _ConfirmWithdrawContainer = _interopRequireDefault(require("../components/ConfirmWithdraw/ConfirmWithdrawContainer"));
var _DepositConfirmationModalContainer = _interopRequireDefault(require("../components/DepositConfirmation/DepositConfirmationModalContainer"));
var _StandaloneLoginFormContainer = _interopRequireDefault(require("../components/Login/StandaloneLoginFormContainer"));
var _VerifyAddressContainer = _interopRequireDefault(require("../components/VerifyAddress/VerifyAddressContainer"));
var _VerifyDeviceContainer = _interopRequireDefault(require("../components/VerifyDevice/VerifyDeviceContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var STAND_ALONE_COMPONENTS = exports.STAND_ALONE_COMPONENTS = {
  VerifyEmailContainer: _VerifyEmailContainer["default"],
  ResetPasswordNoAuthFormContainer: _ResetPasswordFormContainer["default"],
  ConfirmWithdrawContainer: _ConfirmWithdrawContainer["default"],
  DepositConfirmationContainer: _DepositConfirmationModalContainer["default"],
  StandaloneLoginContainer: _StandaloneLoginFormContainer["default"],
  VerifyAddressContainer: _VerifyAddressContainer["default"],
  VerifyDeviceContainer: _VerifyDeviceContainer["default"]
};